const theme = {
  colors: {
    primary: "#110e1b",        // font and dark accent
    secondary: "#db2762",      // main color 1
    tertiary: "#12eaea",       // main color 2
    background: "#fefefc",     // background color
    accent1: "#f1de7c",        // accent color 1 - yellow
    accent2: "#bce7fd",        // accent color 2 - light blue
    accent3: "#c492b1",        // accent color 3 - light purple
    green: "#4DDA61",
    purple: "#BDB3EF",
    pink: "#FFA5D2",
    lightGreen: "#CDFF9B",
    cardBg: {
      primary: "#db2762",      // main color 1
      secondary: "#12eaea",    // main color 2
      lightBlue: "#bce7fd",    // accent color 2
      yellow: "#f1de7c",       // accent color 1
      lightPurple: "#c492b1"   // accent color 3
    }
  },
  fonts: {
    heading: "'Open Sans', sans-serif",
    body: "'Open Sans', sans-serif"
  },
  borderRadius: {
    small: "12px",
    medium: "20px",
    large: "32px"
  },
  mobileBreakpoint: 768,
};

export const mobileBreakpoint = 768;
export default theme; 